module.exports = __webpack_public_path__ + "assets/img/store_entry.bdd4b65e.jpg";